import { create } from 'zustand';

export interface SessionUser {
  username: string;
  name: string;
  email?: string;
  roles: string[];
}

interface AuthState {
  authenticated: boolean;
  initialized: boolean;
  token: string | null;
  user: SessionUser | null;
  set: (partial: Partial<AuthState>) => void;
  reset: () => void;
}

/**
 * Session store. The Bearer token is kept here and read by the api client.
 * Keycloak (or the mock adapter) is the single writer.
 */
export const useAuthStore = create<AuthState>((set) => ({
  authenticated: false,
  initialized: false,
  token: null,
  user: null,
  set: (partial) => set(partial),
  reset: () =>
    set({ authenticated: false, token: null, user: null }),
}));

export const getToken = () => useAuthStore.getState().token;
